export default {
  p_matpl: {
    title: 'MatPL 简介',
    titleP1: `
        人工智能与传统计算机模拟的结合已经成为现代科学计算的一大趋势。
        在这个趋势中，机器学习力场的研究和应用成为了一个重要的方向。
        机器学习力场能够显著提升分子动力学模拟的精度和效率，这对于科学研究和工程应用都具有重要的意义。
    `,
    titleP2: `
        Materials Potential Library (MatPL) 是一套由龙讯团队开发的开源软件包，由原 PWMLFF 发展而来，
        它在GNU许可下开放源代码。MatPL 的主要功能是快速生成机器学习力场，
        这些力场的精度可以与从头算分子动力学（AIMD）相媲美。
        这意味着，使用PWMLFF，研究人员可以在短时间内获得高精度的模拟结果，大大提高了研究效率。
    `,
    titleP3: `
        MatPL 提供了一整套的解决方案，包括模型训练平台、Lammps的libtorch接口方案、主动学习平台、数据格式转换工具等。
        此外，它还提供了数据和模型仓库，以及详细的用户手册。这些功能和资源为用户提供了全方位的支持，
        使得用户可以更方便、更高效地使用MatPL进行科学计算和模拟。
    `,
    matplT1: '用户手册',
    matplT1P1: 'MatPL 用户手册提供了详细的MatPL工具集安装、使用以及案例说明文档',
    matplT2: '机器学习平台',
    matplT2P1: '支持8种常见描述符、4种机器学习模型以及2种训练优化器',
    matplT3: '接口',
    matplT3P1: '与 MatPL 模型无缝集成，支持 CPU、GPU 多卡分子动力学模拟',
    matplT4: '主动学习平台(支持 pip install pwact)',
    matplT4P1: '自动化主动学习采样，快速制备 MatPL 训练数据，支持 PWmat、VASP、CP2K、DFTB(PWmat集成)等常用第一性原理软件',
    matplT5: '结构转换工具 PWdata (支持 pip install pwdata)',
    matplT5P1: '支持PWmat、VASP、CP2K、Lammps 之间的结构格式互转，支持各类结构到 pwmlff/npy, extxyz 数据格式转换',
    matplT6: '训练数据集仓库',
    matplT6P1: '百度网盘下载：',
    matplT6P2: '包含了常见体系的 AIMD 数据集、一些已经过充分训练的 MatPL 模型。便于用户快速复用数据集和模型，节省数据制备和模型训练成本。',
    matplT7: '测试案例',
    matplT7P1: 'MatPL 的测试结果以及使用 MatPL 的相关案例',
  },
  p_ls3df: {
    title: 'LS3DF 简介',
    titleP1: `
            LSEDF(线性标度三维分块算法)基于分而治之的思想，将大体系划分为许多小片段，每个小片段单独用DFT方法进行计算，
            然后将计算完的小片段组合拼接起来，从而得到大体系的电子结构性质。
            线性标度三维分块算法得以实施的基础是总能可以分为两部分：静电能和量子机械能（例如，动能和交换关联能）。
            其中静电能是远程的作用，所以必须对整体求解一个泊松方程，而计算昂贵的量子机械能是短程的作用，
            所以将整个系统切分成小片段，分别单独计算这些小片段的量子机械能，然后结合每个小片段DFT计算的能量，
            从而获得整个系统的能量。这其中需要解决的关键问题是如何组合拼接小片段，
            北京龙讯旷腾科技有限公司提出了一种新颖的拼接方案，可以通过特殊求和消除边界影响。
            在该计算方法中，一旦小片段尺寸被确定，以获得给定的数值精度，计算量与小片段数量成正比，
            因此，我们称其为线性标度三维分块方法。
    `,
    titleP2: `
            LS3DF用途广泛，可以用于晶界、位错、缺陷、非晶态或者实际器件研究。
            2020年,龙讯旷腾与中国科学院半导体研究所合作，在200个GPU的超算平台（Mstation
            Cluster，以下简称Mcluster）上实现了平面波精度的10万原子体系计算。
            2022年，龙讯旷腾与腾讯量子实验室、腾讯云高性能计算产品团队、盐城工学院石林教授团队联合攻关，
            成功实现了百万硅原子超大规模体系的平面波精度第一性原理计算。
    `,
    ls3dfT1: '相关下载',
    ls3dfT1P1: 'LS3DF安装包下载地址',
  }
}